/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { isStaff } from '../../../../selectors/user'
import NotAuthorised from '../../../../routes/not-authorised';
import { MaterialityAssessmentTestingTool } from '../../components/TestingTool';
import { useAppSelector } from '../../../../reducers';

export function TestingToolRoute() {
  const userIsStaff = useAppSelector(isStaff);

  if (!userIsStaff) {
    return <NotAuthorised />;
  }

  return (
    <MaterialityAssessmentTestingTool />
  )
}
